import { IMessage } from '@weblite/ts-action/message'
// Logic
import { useRoomAttribute } from '$logic/room/react-hook'
import { usePrivateSpace } from '$logic/private-space/react-hook'
import { t } from '$i18n'
import { useRoomLastMessage } from '$logic/room-last-message/react-hook'
import { EventTitle } from '$common/chat-list-item-new/components/event-title'
import { getAvatarText } from '$func/avatar-text'
import { SelectableAvatar } from '$common/avatar'
import { AvatarSize } from '$common/avatar/avatar-base/types'
// Components
import { ChatListItemBase } from './chat-list-item-base'
import { ChatListItemProps } from './chat-list-item.types'
import { getLastMessageText } from './hooks/chat-list-item-hooks'

// TODO: IMPLEMENT PENDING MESSAGE ICON IN STATUS
export function PrivateSpaceChatListItem({
  selected,
  pinned,
  isOnTop,
  chatId,
  onClick,
  onContextMenu,
  onLongPress,
  isOpened,
}: ChatListItemProps) {
  const lastMessage = useRoomLastMessage(chatId)
  const roomCreatedAt = useRoomAttribute('createdAt', chatId)
  const lastMessageSentWappName = getLastMessageText(lastMessage)

  const privateSpace = usePrivateSpace()

  return (
    <ChatListItemBase
      chatId={chatId}
      avatarElement={
        <SelectableAvatar
          checked={selected}
          src="assets/svg/private-space.svg"
          avatarBackgroundText={getAvatarText(t('chatList.privateSpace'))}
          size={AvatarSize.LG}
        />
      }
      selected={selected}
      roomType="PRIVATE_SPACE"
      title={t('chatList.privateSpace')}
      date={lastMessage?.date || roomCreatedAt}
      lastMessageType={lastMessage?.type}
      lastMessageBody={lastMessageSentWappName || ''}
      pinned={pinned}
      hasMarkAsUnread={privateSpace?.unreadMark}
      eventTitle={<EventTitle lastMessage={lastMessage as IMessage} />}
      isOnTop={isOnTop}
      links={(lastMessage as IMessage)?.links}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onLongPress={onLongPress}
      isOpened={isOpened}
    />
  )
}
